import { render, staticRenderFns } from "./EditNoteInline.vue?vue&type=template&id=20bb75bc&scoped=true&"
import script from "./EditNoteInline.vue?vue&type=script&lang=js&"
export * from "./EditNoteInline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb75bc",
  null
  
)

export default component.exports